import apiETCE from "../infra/apiETCE"

const InteressadoService = {
    ConsulteNomeCpfCnpj: async (dado) => {
        return await apiETCE.get(`/api/v1/Interessado/consulte/nomecpfcnpj/${dado}`)
    },
}

export default InteressadoService